import React, { useState, useRef } from "react";

const NewTopDevelopers = ({ developers }) => {
  const [filteredDevelopers, setFilteredDevelopers] = useState(developers);
  const scrollContainerRef = useRef(null);
  const [selectedLocation, setSelectedLocation] = useState("");
  // Function to filter developers based on location
  const filterDevelopers = (location) => {
    if (location) {
      setFilteredDevelopers(
        developers.filter((dev) => dev.location === location)
      );
      setSelectedLocation(location);
    } else {
      setFilteredDevelopers(developers);
      setSelectedLocation(""); // Show all developers initially
    }
  };

  return (
    <div className="w-full flex justify-center bg-[#384152] overflow-hidden mt-10">
      <div className="w-full flex flex-col py-5">
        <div className="flex flex-col items-center">
          {/* Heading Section */}
          <div className="mb-2 py-3">
            <div className="text-white font-normal text-center text-[16px]">
              Where Luxury Meets Expertise
            </div>
            <div className="text-white text-[24px] font-bold text-center">
              Leading Real Estate Developers
            </div>
          </div>

          {/* Filter Buttons */}
          {/* Filter Buttons (Responsive: 2x2 grid on mobile, row on desktop) */}
          <div className="md:flex hidden grid grid-cols-2 gap-4 mb-4 w-full max-w-xs md:flex md:flex-row md:justify-center">
            {["mumbai", "pune", "bengaluru", "gurugram"].map((location) => (
              <button
                key={location}
                onClick={() => filterDevelopers(location)}
                className={`px-4 py-2 font-semibold rounded-lg transition ${
                  selectedLocation === location
                    ? " bg-white text-[#384152] hover:bg-gray-200 " // Active button
                    : "border-2 border-white bg-[#374151] text-white" // Default button
                }`}
              >
                {location.charAt(0).toUpperCase() + location.slice(1)}
              </button>
            ))}
            <button
              onClick={() => filterDevelopers("")}
              className={`col-span-2 px-4 py-2 font-semibold rounded-lg transition ${
                selectedLocation === ""
                  ? " bg-white text-[#384152] hover:bg-gray-200 "
                  : "bg-[#384152] text-white border-2 border-white"
              }`}
            >
              All
            </button>
          </div>
          {/* Mobile View (Only 4 Buttons, 2x2 Layout) */}
          <div className="flex md:hidden grid grid-cols-2 gap-2 mb-4 w-full px-4">
            {["mumbai", "pune", "bengaluru", "gurugram"].map((location) => (
              <button
                key={location}
                onClick={() => filterDevelopers(location)}
                className={`px-4 py-2 font-semibold rounded-lg transition ${
                  selectedLocation === location
                    ? "bg-[#384152] text-white" // Active button
                    : "bg-white text-[#384152] hover:bg-gray-200" // Default button
                }`}
              >
                {location.charAt(0).toUpperCase() + location.slice(1)}
              </button>
            ))}
          </div>

          {/* Developers Grid */}
          <div
            className="relative w-full h-[450px] overflow-y-auto scrollbar-hide flex  justify-center"
            ref={scrollContainerRef}
          >
            <div className="w-full md:w-[80%] grid grid-cols-2 sm:grid-cols-3 md:grid-cols-3 lg:grid-cols-4 gap-4 p-4">
              {filteredDevelopers.map((developer, index) => (
                <a key={index} href={developer.link} className="w-full">
                  <div className="p-0 md:p-10 rounded-lg border-2 w-full h-[120px] md:h-[150px] aspect-[4/3] flex justify-center items-center bg-white hover:scale-105 hover:shadow-xl transition-transform duration-300">
                    <img
                      src={developer.image}
                      alt={developer.alt}
                      className="object-contain w-full h-full"
                    />
                  </div>
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewTopDevelopers;
